import React from 'react';
import { Alert, Button, Card, Space, Typography } from 'antd';
import { BuildOutlined, PlusOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

const NewCompanyTab: React.FC = () => (
  <Card
    className="configuration-new-company-card"
    title={
      <Space>
        <BuildOutlined />
        Create New Company
      </Space>
    }
  >
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Paragraph>
        <strong>Company Creation Process:</strong> Any user can create their own company and become
        its administrator. This process requires sales team approval for security and compliance.
      </Paragraph>

      <Alert
        className="configuration-new-company-alert"
        message="Sales Representative Approval Required"
        description="All new company registrations go through our sales team for verification. You'll receive a company creation token within 1-2 business days."
        type="info"
        showIcon
      />

      <div>
        <Text strong>What happens next:</Text>
        <ol style={{ marginTop: '8px', marginLeft: '16px' }}>
          <li>Submit company registration request</li>
          <li>Sales team reviews and approves your request</li>
          <li>Receive company creation token via email</li>
          <li>Complete company setup with business details</li>
          <li>Become administrator of your new company</li>
        </ol>
      </div>

      <Button
        className="configuration-new-company-start-button"
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => {
          window.location.href = '/login';
        }}
      >
        Start Company Registration Process
      </Button>
    </Space>
  </Card>
);

export default NewCompanyTab;
